import { Box } from '@mui/material';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Sidebar from '@common/components/custom/Sidebar/Sidebar';
import DashboardMainContainer from './DashboardMainContainer';
import { dashboardContainer } from './DashboardSx';
import { SidebarOptions } from '../../utils/constants/sidebar';
import DashboardPage from './screens/DashboardPage';
// import MyGarage from "./screens/MyGarage";
import MyGarage from '@common/pages/Dashboard/screens/MyGarage';
import UpcomingCars from './screens/UpcomingCars';
import LiveAuctionCars from './screens/LiveAuction';
import CarsInNegotiation from './screens/CarsInNegotiation';
import { CarEstimateAndAuctionForm } from '@common/pages/CarEstimate/CarEstimateAndAuctionForm';
import WatchList from './screens/WatchList';
import { useLocation, useNavigate } from 'react-router-dom';
import { routes } from '../../utils/constants/routes';
import { setActiveSidebar } from '../../toolkit/sidebar/sidebarSlice';
import { reducerPaths } from '../../app/reducerPaths';
import BuyNow from './screens/BuyNow';
import MyOrders from './screens/MyOrders';
import { findHighestCommonCharactersWithSingleString } from '@common/utils/methods/generalMethods';
import Profile from './screens/Profile';

const Dashboard = () => {
  // useLocation...
  const location = useLocation();
  // useLocation...

  // useNavigate...
  const navigate = useNavigate();
  // useNavigate...

  // useDispatch...
  const dispatch = useDispatch();
  // useDispatch...

  const subPath = location?.pathname?.split?.(`${routes.dashboardNavigation}`)?.[1];

  console.log(location, `location`);

  const { activeSidebar } = useSelector((state) => state.sidebar);
  const { token } = useSelector((state) => state[reducerPaths.auth]);
  // const getActiveScreen = (activeSidebar) => {
  //   switch (activeSidebar.value) {
  //     case SidebarOptions[0].value: // "sellMyCar"
  //       return <DashboardPage />;
  //     case SidebarOptions[1].value: // "my garage"
  //       return <MyGarage />;
  //     case SidebarOptions[2].value: // "upcoming cars"
  //       return <UpcomingCars />;
  //     case SidebarOptions[3].value: // "upcoming cars"
  //       return <LiveAuctionCars />;
  //     case SidebarOptions[4].value: // "upcoming cars"
  //       return <CarsInNegotiation />;
  //     case SidebarOptions[5].value: // "upcoming cars"
  //       return <WatchList />;
  //     default:
  //       return null;
  //   }
  // };

  // function findHighestCommonCharactersWithSingleString(arr, targetStr) {
  //   if (!Array.isArray(arr) || arr.length === 0 || typeof targetStr !== 'string') {
  //     return null; // Handle invalid inputs
  //   }

  //   let highestCount = 0;
  //   let result = null;

  //   // Use a Set to store unique characters of the target string for efficient lookup
  //   const targetChars = new Set(targetStr);

  //   for (const str of arr) {
  //     let commonCount = 0;
  //     // Use another Set to count common unique characters in the current array string
  //     const commonChars = new Set();

  //     for (const char of str) {
  //       if (targetChars.has(char)) {
  //         commonChars.add(char);
  //       }
  //     }

  //     commonCount = commonChars.size;

  //     if (commonCount > highestCount) {
  //       highestCount = commonCount;
  //       result = str;
  //     }
  //   }

  //   return result;
  // }

  const getActiveScreen = (subPath) => {
    switch (true) {
      case '/' === subPath: // Matches "/" or an empty string
      case '' === subPath: // Matches "/" or an empty string
        return <DashboardPage />;
      case new RegExp(`^${routes.buyNow}\\.*`).test(subPath):
        return <BuyNow />;
      case new RegExp(`^${routes.upcomingCars}\\.*`).test(subPath):
        return <UpcomingCars />;
      case new RegExp(`^${routes.liveAuction}\\.*`).test(subPath): // "liveAuction"
        return <LiveAuctionCars />;
      case new RegExp(`^${routes.carsInNegotiation}\\.*`).test(subPath) ||
        new RegExp(`^${routes.carsInNegotiationBuyNow}\\.*`).test(subPath): // "carsInNegotiation"
        return <CarsInNegotiation />;
      case new RegExp(`^${routes.carEstimate}\\.*`).test(subPath): // "liveAuction"
        return <CarEstimateAndAuctionForm />;
      // case SellerSidebarOptions[4].value: // "unsoldCars"
      //   return <UnsoldCars />;
      case routes.watchList === subPath: // "watch list"
        return <WatchList />;
      case new RegExp(`^${routes.myOrders}(/\\d+)?$`).test(subPath):
        return <MyOrders />;
      case new RegExp(`^${routes.profile}`).test(subPath):
        return <Profile />;
      case RegExp(`^${routes.myGarage}\\.*`).test(subPath): // "myGarage"
        return <MyGarage />;
      default: {
        navigate(`${routes.dashboardNavigation}${routes.myGarage}`);
      }
    }
  };

  React.useEffect(() => {
    const navigationRoutes = SidebarOptions.map((option) => option.navigationRoute);

    const result = findHighestCommonCharactersWithSingleString(navigationRoutes, subPath);

    // if (subPath !== "" && result !== subPath) {
    //   navigate(`${routes.dashboardNavigation}${routes.myGarage}`);
    //   return;
    // }

    console.log(result, subPath, navigationRoutes, `findHighestCommonCharactersWithSingleString`);

    const toBeActiveSidebar = SidebarOptions?.find((option) => {
      if (subPath === '' || subPath === '/') {
        return option.value === 'dashboard';
      } else {
        return option.value !== 'dashboard' && option.navigationRoute === result;
      }
    });

    console.log(subPath, toBeActiveSidebar, `toBeActiveSidebar`);

    dispatch(setActiveSidebar(toBeActiveSidebar));
  }, [subPath]);

  // React.useEffect(() => {
  //   if (!subPath) {
  //     navigate(`${routes.dashboardNavigation}${routes.myGarage}`)
  //   }
  // }, [subPath]);

  React.useEffect(() => {
    if (!token) {
      navigate(routes.authSignin);
      return;
    }
  }, [token, navigate]);

  console.log(subPath, `Dashboard_comp`);

  return (
    <Box sx={dashboardContainer}>
      {/* <Sidebar
        sidebarOptions={SidebarOptions}
      /> */}
      <DashboardMainContainer
        userRoleLabel={"Dealer"}
      >
        {getActiveScreen(subPath)}
      </DashboardMainContainer>
    </Box>
  );
};

export default Dashboard;
